import React, { useState, useEffect } from 'react';
import { 
  X, 
  Briefcase,
  Save,
  Loader2
} from 'lucide-react';
import styles from './DesignationDrawer.module.css';
import api from '../../api/axios';
import toast from 'react-hot-toast';

const DesignationDrawer = ({ isOpen, onClose, onSave, designation = null }) => {
  const [formData, setFormData] = useState({
    designation_name: '',
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (designation) {
        setFormData({
          designation_name: designation.designation_name || '',
        });
      } else {
        setFormData({
          designation_name: '',
        });
      }
    }
  }, [isOpen, designation]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let response;
      if (designation) {
        response = await api.put(`/designations/${designation.id}`, formData);
      } else {
        response = await api.post('/designations', formData);
      }

      if (response.data.success) {
        toast.success(designation ? 'Designation updated successfully' : 'Designation added successfully');
        onSave();
        onClose();
      }
    } catch (error) {
      console.error('Error saving designation:', error);
      const message = error.response?.data?.message || 'Failed to save designation';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles['drawer-backdrop']} onClick={onClose}>
      <div className={styles['drawer-container']} onClick={e => e.stopPropagation()}>
        <div className={styles['drawer-header']}>
          <div className={styles['header-title-wrapper']}>
            <h2>{designation ? 'Edit Designation' : 'Add Designation'}</h2>
            <p>Fill in the designation details</p>
          </div>
          <button className={styles['close-btn']} onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles['drawer-form']}>
          <div className={styles['form-scroll-area']}>
            {/* Designation Name */}
            <div className={styles['form-group']}>
              <label><Briefcase size={16} /> Designation Name <span className={styles['required-star']}>*</span></label>
              <input 
                type="text" 
                name="designation_name"
                value={formData.designation_name}
                onChange={handleChange}
                placeholder="Enter designation name"
                required
              />
            </div>
          </div>

          <div className={styles['drawer-footer']}>
            <button type="button" className={styles['cancel-btn']} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className={styles['save-btn']} disabled={loading}>
              {loading ? <Loader2 size={18} className={styles['spinner']} /> : <Save size={18} />}
              <span>{designation ? 'Update Designation' : 'Save Designation'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DesignationDrawer;
